<template>
  <div class="change-router">
    <div class="change-router-list">
      <div class="change-router-list__item change-router-list__item-1"></div>
      <div class="change-router-list__item change-router-list__item-2"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>

</style>
